import { getCADETESImportFiles } from '@/services/import.service';

const initState = {
  currentImports: [],
};

const Model = {
  namespace: 'importCADETES',
  state: initState,

  effects: {
    *setImporter({ payload }, { put }) {
      yield put({
        type: 'save',
        payload: { currentImports: payload, completed: true },
      });
    },
    *fetch(_, { call, put }) {
      yield put({
        type: 'save',
        payload: { loading: true },
      });

      const response = yield call(getCADETESImportFiles, { uncompleted: true });
      yield put({
        type: 'save',
        payload: { currentImports: response.data.results },
      });

      yield put({
        type: 'save',
        payload: { loading: false },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return { ...state, ...payload };
    },

    clear() {
      return initState;
    },
  },
};
export default Model;
